// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { onePageCheckoutConfirmationActionsStyles } from "@sc/App/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationActions";
import AddToList from "@sc/XDL/Icons/AddToList";
import Print from "@sc/XDL/Icons/Print";
import { createLinkIconStyles } from "@sc/XDL/Utilities";
import { css } from "styled-components";

onePageCheckoutConfirmationActionsStyles.wrapper = {
    css: css`
        display: flex;
        column-gap: 24px;
    `,
};

onePageCheckoutConfirmationActionsStyles.addAllToListLink = {
    ...createLinkIconStyles(AddToList, {
        icon: {
            iconProps: {
                size: 13,
                css: css`
                    &,
                    svg {
                        width: 12px;
                    }
                `,
            },
        },
    }),
};

onePageCheckoutConfirmationActionsStyles.printLink = {
    ...createLinkIconStyles(Print, {
        icon: {
            iconProps: {
                size: 13,
                css: css`
                    &,
                    svg {
                        width: 12px;
                    }
                `,
            },
        },
    }),
};
